import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { idToLink } from 'inside-out/managers/navManager';
import { linkWithFilter } from 'inside-out/managers/newsAndEventsManager';

import { Cards } from 'inside-out/components/shared/cards';
import { NewsCard } from 'inside-out/components/shared/cards/newsCard';
import { CommonPageHeader } from 'inside-out/components/news-and-events/commonPageHeader';
import { CommonFilterBar } from 'inside-out/components/news-and-events/commonFilterBar';
import { CommonSidebar } from 'inside-out/components/news-and-events/commonSidebar';
import { Pagination } from 'inside-out/components/shared/pagination';
import { navigateTo } from 'inside-out/components/shared/link';

import {
	tabPageWrapper,
	innerWrapperStyle,
	sectionStyle,
	leftStyle,
	rightStyle,
	subTitleStyle,
} from 'inside-out/page-styles/news-and-events';

export default class NewsPage extends React.PureComponent {
	static propTypes = {
		pathContext: PropTypes.shape({
			pageNumber: PropTypes.number.isRequired,
			totalPages: PropTypes.number.isRequired,
		}).isRequired,

		data: PropTypes.shape({
			page: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							purple_heading: PropTypes.string.isRequired,
							orange_heading: PropTypes.string.isRequired,
							orange_body: PropTypes.string.isRequired,
							orange_link_text: PropTypes.string.isRequired,
							orange_link_url: PropTypes.string.isRequired,
						}).isRequired,
					})
				).isRequired,
			}).isRequired,

			types: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							title: PropTypes.string.isRequired,
						}).isRequired,
					})
				).isRequired,
			}),

			news: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							id: PropTypes.string.isRequired,
							title: PropTypes.string.isRequired,
							date: PropTypes.string.isRequired,
							extract: PropTypes.string.isRequired,
							fields: PropTypes.shape({
								thumbnail_image: PropTypes.shape({
									childImageSharp: PropTypes.shape({
										resize: PropTypes.shape({
											src: PropTypes.string.isRequired,
										}).isRequired,
									}).isRequired,
								}).isRequired,
							}),
						}).isRequired,
					})
				).isRequired,
			}).isRequired,
		}).isRequired,
	};

	state = {
		search: '',
	};

	render() {
		const { pageNumber, totalPages } = this.props.pathContext;
		const { page, news, types } = this.props.data;
		const { search } = this.state;
		const pageSettings = page.edges[0].node;
		const newsTypes = ((types && types.edges) || []).map(({ node }) => node.title);

		return (
			<React.Fragment>
				<Helmet title="News">
					<meta property="og:type" content="website"/>
			    <meta property="og:title" content="InsideOut - News"/>
				</Helmet>
				<CommonPageHeader activeItem="news" />
				<CommonFilterBar
					placeholderText="Search news"
					onChange={e => this.setState({ search: e.target.value })}
					value={search}
					onSubmit={e => {
						e.preventDefault();
						navigateTo('/news/search-results?query=' + encodeURIComponent(search));
					}}
				/>
				<div className={tabPageWrapper}>
					<div className={innerWrapperStyle}>
						<div className={leftStyle}>
							{news && (
								<section className={sectionStyle}>
									<header>
										<h1 className={subTitleStyle}>Latest News</h1>
									</header>
									<Cards>
										{news.edges.map(({ node }, index) => (
											<NewsCard
												key={index}
												to={idToLink(node.id)}
												title={node.title}
												body={node.extract}
												date={node.date}
												background={
													node.fields && node.fields.thumbnail_image.childImageSharp.resize.src
												}
											/>
										))}
									</Cards>
								</section>
							)}
							{totalPages !== 1 && (
								<Pagination
									initialPage={pageNumber}
									pageCount={totalPages}
									onPageChange={page => {
										navigateTo(linkWithFilter({base: ['news'], page}));
									}}
								/>
							)}
						</div>
						<div className={rightStyle}>
							<CommonSidebar />
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export const query = graphql`
	query NewsLandingPageQuery($skip: Int, $limit: Int) {
		page: allContentJson(filter: { id: { regex: "/content\\/news-and-events-page\\.json/" } }) {
			edges {
				node {
					purple_heading
					orange_heading
					orange_body
					orange_link_text
					orange_link_url
				}
			}
		}

		types: allNewsTypesJson(sort: { fields: [title], order: ASC }) {
			edges {
				node {
					title
				}
			}
		}

		news: allNewsJson(sort: { order: DESC, fields: [date] }, skip: $skip, limit: $limit) {
			edges {
				node {
					id
					title
					date
					extract
					# fields {
					# 	thumbnail_image {
					# 		childImageSharp {
					# 			resize(width: 552, height: 400) {
					# 				src
					# 			}
					# 		}
					# 	}
					# }
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/news-and-events/news/index.js